import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const postPaykuDeposit = async depositData => {
  return await privateRequest.post(`${ConfEnv.API_WALLET.URL_PAYKU_DEPOSIT}`, {
    amount: depositData.amount.toString(),
    currency: depositData.currency,
    payment_method: depositData.paymentMethod,
  });
};

export const getPaykuTransactionStatus = async orderId => {
  return await privateRequest.get(`${ConfEnv.API_WALLET.URL_PAYKU_TRANSACTION_STATUS}/${orderId}`);
};

export const postPaykuWithdrawal = async withdrawalData => {
  return await privateRequest.post(`${ConfEnv.API_WALLET.URL_PAYKU_WITHDRAWAL}`, {
    amount: withdrawalData.amount,
    currency: withdrawalData.currency,
    beneficiaryName: withdrawalData.beneficiaryName,
    email: withdrawalData.email,
    phone: withdrawalData.phone,
    accountbank_name: withdrawalData.accountbank_name,
    accountbank_rut: withdrawalData.accountbank_rut,
    accountbank_sbif: withdrawalData.accountbank_sbif,
    accountbank_type: withdrawalData.accountbank_type,
    accountbank_num: withdrawalData.accountbank_num,
    provider: "payku",
  });
};

export const getPaykuBanks = async currency => {
  return await privateRequest.get(`${ConfEnv.API_WALLET.URL_PAYKU_BANKS}/${currency}`);
};
